import { FAQLink, FAQTopic } from '@components/FAQ';

import { Sections, Topics } from './constants';

const getCoverDetailsTopics = (): FAQTopic<Topics>[] => [
  {
    id: Topics.boilerCoverVsHomeInsurance,
    question:
      "What's the difference between Boiler & Home Cover and Home Insurance?",
    answer: (
      <>
        Our Boiler & Home Cover focuses on the maintenance and repair of your
        home's heating system and plumbing. It includes an annual boiler
        service, repairs for boilers and central heating, emergency home
        assistance for issues like plumbing, drainage, electrical faults, as
        well as security and pest cover.
        <br />
        <br />
        In contrast, our Home Insurance product provides comprehensive coverage
        for your property and belongings against risks like fire, theft, and
        damage. It includes buildings insurance, contents insurance, or both,
        depending on your needs.
      </>
    ),
  },
  {
    id: Topics.homeEmergency,
    question: 'What is a home emergency?',
    answer: (
      <>
        A sudden and unexpected event which, if not dealt with quickly, would:
        <br />
        <br />
        &#8226; mean your home is unsafe or insecure; or
        <br />
        &#8226; damage or cause further damage to your home; or
        <br />
        &#8226; cause personal risk to you.
      </>
    ),
  },
  {
    id: Topics.annualBoilerService,
    question: 'What does the annual boiler service include?',
    answer: (
      <>
        As part of your service, the engineer will usually:
        <br />
        <br />
        &#8226; visually inspect the boiler and its parts for wear and tear
        <br />
        &#8226; visually check the heat exchanger, electrical connection system
        controls, fans, combustion seals, location and stability, ventilation
        and flue, and operating pressure or gas rate
        <br />
        &#8226; carry out performance tests to check that all parts are working
        correctly
        <br />
        &#8226; evaluate the overall performance to make sure the boiler is
        heating your home efficiently
        <br />
        &#8226; email a copy of your service document that confirms if the
        boiler is safe and highlights any warning notices and gives details of
        any repair work that may be necessary.
        <br />
        <br />
        The following are not included in your service:
        <br />
        <br />
        &#8226; testing the system for the presence of sludge
        <br />
        &#8226; testing and topping up system inhibitor levels
        <br />
        &#8226; repair of damage or faults identified during the service (this
        may be covered by your insurance policy)
        <br />
        &#8226; servicing hot water cylinders
        <br />
        &#8226; servicing gas appliances other than the boiler.
      </>
    ),
  },
  {
    id: Topics.boilerWarranty,
    question: 'My boiler is still in warranty. Do I need Boiler & Home Cover?',
    answer: (
      <>
        The manufacturer’s warranty should protect your boiler. Double-check to
        be on the safe side, and pay attention to how long the warranty lasts.
        <br />
        <br />
        However, our Boiler & Home Cover protects more than just your boiler -
        it will also cover you for issues with your plumbing, drains, electrics,
        locks, roofing, and pests.
      </>
    ),
  },
  {
    id: Topics.oldBoiler,
    question: 'I have an old boiler. Can I still get Boiler & Home Cover?',
    answer: (
      <>
        For Boilers over 10 years old, if we cannot repair it, we can offer a
        financial contribution to a new one. That amount is listed in your
        Policy Schedule and differs based on how long you have held this policy
        <br />
        <br />
        Our Boiler Guarantee - we will replace boilers less than 10 years old
        purchased from and installed by Utility Warehouse or one of our
        subsidiaries where you’ve held cover throughout.
      </>
    ),
  },
  {
    id: Topics.existingProblem,
    question: 'Will you fix an existing problem with my boiler?',
    answer: (
      <>
        Our Boiler & Home Cover does not insure any loss, damage or liability
        arising out of any accident or incident that happened before your policy
        with us has started. We will only pay claims for faults that arise while
        your policy is active.
      </>
    ),
  },
  {
    id: Topics.rentingToTenants,
    question:
      'Is my Boiler & Home Cover still valid if I rent my home out to tenants?',
    answer: (
      <>
        No, the cover is only valid if you or your immediate family are residing
        in the property, so while a portion of the property may be let (e.g a
        spare room), it is not suitable for a property that is wholly let.
      </>
    ),
  },
  {
    id: Topics.coverageDuration,
    question: 'How long am I covered for with this policy?',
    answer: (
      <>
        Your cover is in place for a period of 12 months and will renew
        automatically until cancelled. Your cover will start and end on the
        dates stated in your Policy Schedule.
      </>
    ),
  },
];

const SWITCHING_TOPICS: FAQTopic<Topics>[] = [
  {
    id: Topics.cancelCurrentBoilerCover,
    question:
      "Do I need to tell my current Boiler Cover provider that I'm leaving?",
    answer: (
      <>
        Yes, you'll need to get in touch with your current provider to cancel.
        We recommend that you do this once your policy with us has gone live,
        which will typically happen within one to two working days of submitting
        your order.
      </>
    ),
  },
  {
    id: Topics.coverStartTime,
    question: 'When will my cover start?',
    answer: (
      <>
        Your cover will usually start within one to two working days of
        submitting your order. We'll send you an email to let you know when your
        cover has started.
      </>
    ),
  },
];
const getMakingAClaimTopics = (): FAQTopic<Topics>[] => [
  {
    id: Topics.howToClaim,
    question: 'How do I make a claim on my cover?',
    answer: (
      <>
        If you need to make a claim, please first make sure that you and your
        family are safe, and that police have been informed if necessary. Once
        that is the case, please act quickly and contact the claims team as
        shown in your Policy Schedule.
        <br />
        <br />
        To do this you should:
        <br />
        <br />
        1. Have a look to see if the loss or damage is covered under your
        policy.
        <br />
        <>
          2. Please call <a href="tel:03337773234">0333 777 3234</a>. Make sure
          you have your policy number to hand, which is shown on your policy
          schedule.
        </>
      </>
    ),
  },
  {
    id: Topics.bookingBoilerService,
    question: 'How do I book my boiler service?',
    answer: (
      <>
        The easiest way to book your service is by using the following link{' '}
        <FAQLink href="http://uw.myboilerservicing.co.uk">
          uw.myboilerservicing.co.uk
        </FAQLink>
        . More information can be found within your policy schedule document.
      </>
    ),
  },
  {
    id: Topics.excessFee,
    question: 'Do I have to pay a fee if I make a claim?',
    answer: <>You'll have to pay an excess fee of £60 if you make a claim.</>,
  },
];

// https://docs.google.com/spreadsheets/d/1pyB3gOlAeVUO4ylb-Fh_sDMShp889Pb7qLYL5LAZwuk/edit?gid=0#gid=0
const getFaqSections = () => [
  {
    id: Sections.coverDetails,
    title: 'Cover details',
    topics: getCoverDetailsTopics(),
  },
  {
    id: Sections.switching,
    title: 'Switching',
    topics: SWITCHING_TOPICS,
  },
  {
    id: Sections.makingAClaim,
    title: 'Making a claim',
    topics: getMakingAClaimTopics(),
  },
];

export { getFaqSections };
